
// import React, { useEffect, useRef, useState } from "react";
// import {
//   FiSearch,
//   FiLayers,
//   FiDollarSign,
//   FiCheckCircle,
//   FiArrowUpRight,
//   FiFileText,
//   FiBox,
//   FiGrid,
//   FiClipboard,
//   FiTool,
// } from "react-icons/fi";
// const WhatWeDo = () => {
//   const sectionRef = useRef(null);
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setVisible(true);
//         }
//       },
//       { threshold: 0.12 }
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => observer.disconnect();
//   }, []);

//   const processSteps = [
//     {
//       number: "01",
//       title: "Review",
//       subtitle: "Plans & Documents",
//       description:
//         "We review architectural drawings, structural plans, specifications, schedules, and project documents to understand the complete scope.",
//       icon: FiSearch,
//     },
//     {
//       number: "02",
//       title: "Takeoff",
//       subtitle: "Quantities & Scope",
//       description:
//         "Our estimators measure and quantify materials, components, and trade-specific requirements from the project documents.",
//       icon: FiLayers,
//     },
//     {
//       number: "03",
//       title: "Estimate",
//       subtitle: "Cost Development",
//       description:
//         "We organize material, labor, equipment, and other applicable costs into a structured construction estimate.",
//       icon: FiDollarSign,
//     },
//     {
//       number: "04",
//       title: "Review",
//       subtitle: "Quality Control",
//       description:
//         "The estimate goes through a structured review to identify scope gaps, quantity inconsistencies, and potential errors.",
//       icon: FiCheckCircle,
//     },
//     {
//       number: "05",
//       title: "Deliver",
//       subtitle: "Bid-Ready Output",
//       description:
//         "You receive a clear, organized estimate designed to help your team evaluate costs and prepare competitive bids.",
//       icon: FiArrowUpRight,
//     },
//   ];

//   const divisions = [
//     {
//       number: "01",
//       name: "General Requirements / GC",
//     },
//     {
//       number: "02",
//       name: "Existing Conditions",
//     },
//     {
//       number: "03",
//       name: "Concrete",
//     },
//     {
//       number: "04",
//       name: "Masonry",
//     },
//     {
//       number: "05",
//       name: "Metals",
//     },
//     {
//       number: "07",
//       name: "Thermal & Moisture Protection",
//     },
//     {
//       number: "08",
//       name: "Openings",
//     },
//     {
//       number: "09",
//       name: "Finishes",
//     },
//     {
//       number: "32",
//       name: "Exterior Improvements",
//     },
//   ];

//   return (
//     <>
//       <style>{`

//         /* =====================================================
//            WHAT WE DO
//         ===================================================== */

//         .sg-what {
//           position: relative;
//           overflow: hidden;

//           padding: 125px 0;

//           background: #ffffff;
//         }

//         .sg-what-container {
//           position: relative;
//           z-index: 2;

//           width: min(1380px, 92%);
//           margin: auto;
//         }

//         /* =====================================================
//            BACKGROUND BLUEPRINT
//         ===================================================== */

//         .sg-what-blueprint {
//           position: absolute;

//           right: -180px;
//           top: 180px;

//           width: 650px;
//           height: 650px;

//           opacity: 0.38;

//           background-image:
//             linear-gradient(
//               rgba(25, 88, 175, 0.055) 1px,
//               transparent 1px
//             ),
//             linear-gradient(
//               90deg,
//               rgba(25, 88, 175, 0.055) 1px,
//               transparent 1px
//             );

//           background-size: 35px 35px;

//           transform: rotate(7deg);

//           pointer-events: none;
//         }

//         /* =====================================================
//            SECTION HEADER
//         ===================================================== */

//         .sg-what-heading {
//           display: grid;

//           grid-template-columns: 0.9fr 1.1fr;

//           gap: 80px;

//           align-items: end;

//           margin-bottom: 70px;

//           opacity: 0;
//           transform: translateY(30px);

//           transition:
//             opacity 0.75s ease,
//             transform 0.75s ease;
//         }

//         .sg-what-heading.visible {
//           opacity: 1;
//           transform: translateY(0);
//         }

//         .sg-what-label {
//           display: inline-flex;

//           align-items: center;

//           gap: 9px;

//           margin-bottom: 16px;

//           color: #175bc3;

//           font-size: 12px;

//           font-weight: 800;

//           letter-spacing: 1.5px;

//           text-transform: uppercase;
//         }

//         .sg-what-label-line {
//           width: 30px;
//           height: 2px;

//           border-radius: 10px;

//           background: #f39818;
//         }

//         .sg-what-title {
//           margin: 0;

//           color: #10213f;

//           font-size: clamp(40px, 4.3vw, 63px);

//           line-height: 1.03;

//           letter-spacing: -2.6px;

//           font-weight: 800;
//         }

//         .sg-what-title span {
//           color: #1b60c8;
//         }

//         .sg-what-description {
//           max-width: 650px;

//           margin: 0;

//           color: #68768a;

//           font-size: 16px;

//           line-height: 1.8;
//         }

//         .sg-what-description strong {
//           color: #243852;
//         }

//         /* =====================================================
//            PROCESS VISUAL
//         ===================================================== */

//         .sg-process {
//           position: relative;

//           margin-top: 20px;

//           padding: 45px 35px 42px;

//           border: 1px solid #dfe8f2;

//           border-radius: 24px;

//           background:
//             linear-gradient(
//               135deg,
//               #f8fbff 0%,
//               #ffffff 50%,
//               #f7faff 100%
//             );

//           box-shadow:
//             0 20px 55px rgba(25, 61, 103, 0.07);

//           overflow: hidden;
//         }

//         .sg-process-grid {
//           position: absolute;

//           inset: 0;

//           opacity: 0.55;

//           background-image:
//             linear-gradient(
//               rgba(31, 91, 177, 0.04) 1px,
//               transparent 1px
//             ),
//             linear-gradient(
//               90deg,
//               rgba(31, 91, 177, 0.04) 1px,
//               transparent 1px
//             );

//           background-size: 28px 28px;

//           pointer-events: none;
//         }

//         .sg-process-top {
//           position: relative;

//           z-index: 2;

//           display: flex;

//           align-items: center;

//           justify-content: space-between;

//           margin-bottom: 45px;
//         }

//         .sg-process-heading {
//           color: #10213f;

//           font-size: 20px;

//           font-weight: 800;
//         }

//         .sg-process-tag {
//           padding: 8px 13px;

//           border: 1px solid #d6e2f1;

//           border-radius: 20px;

//           color: #5c6d83;

//           background: #ffffff;

//           font-size: 10px;

//           font-weight: 700;

//           letter-spacing: 0.7px;

//           text-transform: uppercase;
//         }

//         /* =====================================================
//            PROCESS STEPS
//         ===================================================== */

//         .sg-process-steps {
//           position: relative;

//           z-index: 2;

//           display: grid;

//           grid-template-columns:
//             repeat(5, minmax(0, 1fr));

//           gap: 12px;
//         }

//         .sg-process-line {
//           position: absolute;

//           left: 9%;

//           right: 9%;

//           top: 38px;

//           height: 2px;

//           background:
//             repeating-linear-gradient(
//               90deg,
//               #c7d8ed 0,
//               #c7d8ed 7px,
//               transparent 7px,
//               transparent 14px
//             );
//         }

//         .sg-process-step {
//           position: relative;

//           text-align: center;

//           opacity: 0;

//           transform: translateY(25px);

//           transition:
//             opacity 0.6s ease,
//             transform 0.6s ease;
//         }

//         .sg-process-step.visible {
//           opacity: 1;

//           transform: translateY(0);
//         }

//         .sg-process-step:nth-child(2) {
//           transition-delay: 0.12s;
//         }

//         .sg-process-step:nth-child(3) {
//           transition-delay: 0.24s;
//         }

//         .sg-process-step:nth-child(4) {
//           transition-delay: 0.36s;
//         }

//         .sg-process-step:nth-child(5) {
//           transition-delay: 0.48s;
//         }

//         .sg-process-number {
//           position: relative;

//           z-index: 4;

//           width: 76px;
//           height: 76px;

//           display: flex;

//           align-items: center;
//           justify-content: center;

//           margin: auto;

//           border: 7px solid #f8fbff;

//           border-radius: 50%;

//           color: #ffffff;

//           background:
//             linear-gradient(
//               145deg,
//               #1558c0,
//               #2874dd
//             );

//           font-size: 17px;

//           font-weight: 900;

//           box-shadow:
//             0 10px 25px rgba(21, 88, 192, 0.22);

//           transition:
//             transform 0.3s ease,
//             box-shadow 0.3s ease;
//         }

//         .sg-process-step:hover
//         .sg-process-number {
//           transform: scale(1.08);

//           box-shadow:
//             0 15px 32px rgba(21, 88, 192, 0.30);
//         }

//         .sg-process-icon {
//           position: absolute;

//           z-index: 5;

//           top: -4px;

//           right: calc(50% - 38px);

//           transform: translateX(50%);

//           width: 21px;
//           height: 21px;

//           display: flex;

//           align-items: center;
//           justify-content: center;

//           border-radius: 50%;

//           background: #f39818;

//           color: white;

//           font-size: 9px;

//           font-weight: 900;

//           border: 3px solid #ffffff;
//         }

//         .sg-process-title {
//           margin: 19px 0 5px;

//           color: #172945;

//           font-size: 16px;

//           font-weight: 800;
//         }

//         .sg-process-subtitle {
//           color: #1558c0;

//           font-size: 10px;

//           font-weight: 800;

//           letter-spacing: 0.5px;

//           text-transform: uppercase;
//         }

//         .sg-process-text {
//           max-width: 190px;

//           margin: 12px auto 0;

//           color: #7a8799;

//           font-size: 10.5px;

//           line-height: 1.65;
//         }

//         /* =====================================================
//            IMAGE + MESSAGE
//         ===================================================== */

//         .sg-what-main {
//           display: grid;

//           grid-template-columns:
//             0.9fr
//             1.1fr;

//           gap: 80px;

//           align-items: center;

//           margin-top: 100px;
//         }

//         .sg-what-image-area {
//           position: relative;

//           min-height: 480px;

//           opacity: 0;
//           transform: translateX(-35px);

//           transition:
//             opacity 0.8s ease,
//             transform 0.8s ease;
//         }

//         .sg-what-image-area.visible {
//           opacity: 1;
//           transform: translateX(0);
//         }

//         .sg-what-main-image {
//           position: absolute;

//           top: 0;
//           left: 0;

//           width: 84%;
//           height: 385px;

//           object-fit: cover;

//           border-radius: 21px;

//           box-shadow:
//             0 25px 55px rgba(25, 58, 97, 0.17);
//         }

//         .sg-what-small-image {
//           position: absolute;

//           z-index: 3;

//           right: 0;
//           bottom: 5px;

//           width: 50%;
//           height: 210px;

//           object-fit: cover;

//           border: 9px solid #ffffff;

//           border-radius: 18px;

//           box-shadow:
//             0 18px 40px rgba(25, 58, 97, 0.17);
//         }

//         .sg-what-image-card {
//           position: absolute;

//           z-index: 5;

//           left: 25px;
//           bottom: 25px;

//           display: flex;

//           align-items: center;

//           gap: 12px;

//           padding: 13px 16px;

//           border-radius: 12px;

//           background: rgba(255,255,255,0.94);

//           box-shadow:
//             0 15px 35px rgba(25,58,97,0.15);

//           backdrop-filter: blur(12px);

//           animation: sgWhatFloat 4s ease-in-out infinite;
//         }

//         .sg-what-image-card-icon {
//           width: 39px;
//           height: 39px;

//           display: flex;

//           align-items: center;
//           justify-content: center;

//           border-radius: 9px;

//           color: #1558c0;

//           background: #eaf2ff;

//           font-size: 17px;
//         }

//         .sg-what-image-card strong {
//           display: block;

//           color: #172945;

//           font-size: 12px;
//         }

//         .sg-what-image-card span {
//           display: block;

//           margin-top: 3px;

//           color: #8793a3;

//           font-size: 9px;
//         }

//         /* =====================================================
//            RIGHT CONTENT
//         ===================================================== */

//         .sg-what-content {
//           opacity: 0;
//           transform: translateX(35px);

//           transition:
//             opacity 0.8s ease 0.12s,
//             transform 0.8s ease 0.12s;
//         }

//         .sg-what-content.visible {
//           opacity: 1;
//           transform: translateX(0);
//         }

//         .sg-what-content-label {
//           color: #f39818;

//           font-size: 11px;

//           font-weight: 800;

//           letter-spacing: 1.3px;

//           text-transform: uppercase;
//         }

//         .sg-what-content-title {
//           max-width: 620px;

//           margin: 11px 0 18px;

//           color: #10213f;

//           font-size: clamp(30px, 3.1vw, 45px);

//           line-height: 1.12;

//           letter-spacing: -1.5px;

//           font-weight: 800;
//         }

//         .sg-what-content-title span {
//           color: #1b60c8;
//         }

//         .sg-what-content-text {
//           max-width: 620px;

//           margin: 0 0 18px;

//           color: #68768a;

//           font-size: 14px;

//           line-height: 1.8;
//         }

//         /* =====================================================
//            FEATURE LIST
//         ===================================================== */

//         .sg-what-features {
//           display: grid;

//           grid-template-columns: 1fr 1fr;

//           gap: 13px;

//           margin-top: 28px;
//         }

//         .sg-what-feature {
//           display: flex;

//           align-items: center;

//           gap: 10px;

//           padding: 13px;

//           border: 1px solid #e4ebf3;

//           border-radius: 10px;

//           background: #fbfdff;

//           color: #40516a;

//           font-size: 11px;

//           font-weight: 700;

//           transition:
//             border-color 0.25s ease,
//             transform 0.25s ease,
//             background 0.25s ease;
//         }

//         .sg-what-feature:hover {
//           transform: translateY(-3px);

//           border-color: #cbdcf1;

//           background: #ffffff;
//         }

//         .sg-what-feature-icon {
//           width: 27px;
//           height: 27px;

//           flex-shrink: 0;

//           display: flex;

//           align-items: center;
//           justify-content: center;

//           border-radius: 7px;

//           color: #1558c0;

//           background: #eaf2ff;

//           font-size: 11px;
//         }

//         /* =====================================================
//            CSI DIVISIONS
//         ===================================================== */

//         .sg-divisions-section {
//           margin-top: 105px;

//           padding: 50px;

//           border-radius: 22px;

//           background:
//             linear-gradient(
//               135deg,
//               #102b4d,
//               #174d88
//             );

//           box-shadow:
//             0 25px 60px rgba(15, 48, 85, 0.18);

//           overflow: hidden;

//           position: relative;
//         }

//         .sg-divisions-section::after {
//           content: "";

//           position: absolute;

//           width: 420px;
//           height: 420px;

//           right: -150px;
//           top: -200px;

//           border: 1px solid rgba(255,255,255,0.10);

//           border-radius: 50%;
//         }

//         .sg-divisions-header {
//           position: relative;

//           z-index: 2;

//           display: flex;

//           align-items: flex-end;

//           justify-content: space-between;

//           gap: 40px;

//           margin-bottom: 35px;
//         }

//         .sg-divisions-label {
//           color: #f7a62c;

//           font-size: 10px;

//           font-weight: 800;

//           letter-spacing: 1.4px;

//           text-transform: uppercase;
//         }

//         .sg-divisions-title {
//           max-width: 600px;

//           margin: 9px 0 0;

//           color: #ffffff;

//           font-size: clamp(28px, 3vw, 40px);

//           line-height: 1.15;

//           letter-spacing: -1px;

//           font-weight: 800;
//         }

//         .sg-divisions-description {
//           max-width: 430px;

//           margin: 0;

//           color: rgba(255,255,255,0.68);

//           font-size: 12px;

//           line-height: 1.7;
//         }

//         .sg-divisions-grid {
//           position: relative;

//           z-index: 2;

//           display: grid;

//           grid-template-columns:
//             repeat(3, 1fr);

//           gap: 10px;
//         }

//         .sg-division-card {
//           display: flex;

//           align-items: center;

//           gap: 12px;

//           min-height: 65px;

//           padding: 10px 14px;

//           border: 1px solid rgba(255,255,255,0.10);

//           border-radius: 10px;

//           background: rgba(255,255,255,0.065);

//           transition:
//             background 0.25s ease,
//             transform 0.25s ease,
//             border-color 0.25s ease;
//         }

//         .sg-division-card:hover {
//           transform: translateY(-3px);

//           background: rgba(255,255,255,0.12);

//           border-color: rgba(255,255,255,0.20);
//         }

//         .sg-division-number {
//           width: 37px;
//           height: 37px;

//           flex-shrink: 0;

//           display: flex;

//           align-items: center;
//           justify-content: center;

//           border-radius: 8px;

//           color: #174f9b;

//           background: #ffffff;

//           font-size: 11px;

//           font-weight: 900;
//         }

//         .sg-division-card strong {
//           display: block;

//           color: #ffffff;

//           font-size: 11px;

//           line-height: 1.35;
//         }

//         .sg-division-card span {
//           display: block;

//           margin-top: 3px;

//           color: rgba(255,255,255,0.46);

//           font-size: 8px;

//           letter-spacing: 0.5px;

//           text-transform: uppercase;
//         }

//         /* =====================================================
//            CTA
//         ===================================================== */

//         .sg-what-cta {
//           display: flex;

//           align-items: center;
//           justify-content: space-between;

//           gap: 30px;

//           margin-top: 75px;

//           padding: 32px 35px;

//           border: 1px solid #dce7f3;

//           border-radius: 18px;

//           background: #f7faff;
//         }

//         .sg-what-cta-title {
//           margin: 0;

//           color: #10213f;

//           font-size: 22px;

//           font-weight: 800;
//         }

//         .sg-what-cta-text {
//           margin: 7px 0 0;

//           color: #778497;

//           font-size: 11px;
//         }

//         .sg-what-cta-button {
//           display: inline-flex;

//           align-items: center;
//           justify-content: center;

//           gap: 8px;

//           min-height: 48px;

//           padding: 0 21px;

//           flex-shrink: 0;

//           border-radius: 8px;

//           color: white;

//           background: #1558c0;

//           text-decoration: none;

//           font-size: 11px;

//           font-weight: 800;

//           transition:
//             transform 0.25s ease,
//             background 0.25s ease;
//         }

//         .sg-what-cta-button:hover {
//           transform: translateY(-2px);

//           background: #10499f;
//         }

//         /* =====================================================
//            ANIMATION
//         ===================================================== */

//         @keyframes sgWhatFloat {
//           0%,
//           100% {
//             transform: translateY(0);
//           }

//           50% {
//             transform: translateY(-9px);
//           }
//         }

//         /* =====================================================
//            TABLET
//         ===================================================== */

//         @media (max-width: 1000px) {

//           .sg-what {
//             padding: 95px 0;
//           }

//           .sg-what-heading {
//             gap: 40px;
//           }

//           .sg-process {
//             padding: 35px 20px;
//           }

//           .sg-process-steps {
//             gap: 5px;
//           }

//           .sg-process-text {
//             font-size: 9px;
//           }

//           .sg-what-main {
//             gap: 45px;
//           }

//           .sg-divisions-section {
//             padding: 40px 30px;
//           }
//         }

//         /* =====================================================
//            MOBILE
//         ===================================================== */

//         @media (max-width: 760px) {

//           .sg-what {
//             padding: 80px 0;
//           }

//           .sg-what-heading {
//             grid-template-columns: 1fr;

//             gap: 18px;

//             text-align: center;

//             margin-bottom: 45px;
//           }

//           .sg-what-label {
//             justify-content: center;
//           }

//           .sg-what-title {
//             font-size: 39px;

//             letter-spacing: -1.7px;
//           }

//           .sg-what-description {
//             margin: auto;

//             font-size: 15px;
//           }

//           .sg-process {
//             padding: 30px 18px;
//           }

//           .sg-process-top {
//             display: block;

//             text-align: center;
//           }

//           .sg-process-tag {
//             display: inline-block;

//             margin-top: 10px;
//           }

//           .sg-process-steps {
//             grid-template-columns: 1fr;

//             gap: 25px;
//           }

//           .sg-process-line {
//             left: 50%;

//             right: auto;

//             top: 35px;

//             bottom: 35px;

//             width: 2px;

//             height: auto;

//             background:
//               repeating-linear-gradient(
//                 180deg,
//                 #c7d8ed 0,
//                 #c7d8ed 7px,
//                 transparent 7px,
//                 transparent 14px
//               );
//           }

//           .sg-process-step {
//             display: grid;

//             grid-template-columns: 70px 1fr;

//             column-gap: 18px;

//             text-align: left;

//             align-items: center;
//           }

//           .sg-process-number {
//             grid-row: span 3;

//             width: 70px;
//             height: 70px;

//             margin: 0;
//           }

//           .sg-process-icon {
//             top: -1px;

//             right: auto;

//             left: 49px;

//             transform: none;
//           }

//           .sg-process-title {
//             margin: 0 0 3px;

//             font-size: 15px;
//           }

//           .sg-process-subtitle {
//             font-size: 9px;
//           }

//           .sg-process-text {
//             max-width: none;

//             margin: 7px 0 0;

//             font-size: 10px;
//           }

//           .sg-what-main {
//             grid-template-columns: 1fr;

//             gap: 45px;

//             margin-top: 75px;
//           }

//           .sg-what-image-area {
//             min-height: 410px;
//           }

//           .sg-what-main-image {
//             width: 86%;
//             height: 320px;
//           }

//           .sg-what-small-image {
//             width: 53%;
//             height: 175px;
//           }

//           .sg-what-content-title {
//             font-size: 32px;
//           }

//           .sg-what-features {
//             grid-template-columns: 1fr;
//           }

//           .sg-divisions-section {
//             margin-top: 75px;

//             padding: 35px 22px;
//           }

//           .sg-divisions-header {
//             display: block;

//             text-align: center;
//           }

//           .sg-divisions-description {
//             margin: 17px auto 0;
//           }

//           .sg-divisions-grid {
//             grid-template-columns: 1fr;
//           }

//           .sg-what-cta {
//             display: block;

//             text-align: center;

//             padding: 28px 20px;
//           }

//           .sg-what-cta-button {
//             width: 100%;

//             margin-top: 22px;
//           }
//         }
//          .sg-process-icon {
//   position: absolute;
//   z-index: 5;
//   top: -4px;
//   right: calc(50% - 38px);
//   transform: translateX(50%);

//   width: 23px;
//   height: 23px;

//   display: flex;
//   align-items: center;
//   justify-content: center;

//   border-radius: 50%;

//   background: #f39818;
//   color: white;

//   font-size: 10px;
//   font-weight: 900;

//   border: 3px solid #ffffff;
// }
//   .sg-what-image-card-icon svg {
//   width: 18px;
//   height: 18px;
// }
//   .sg-what-feature-icon svg {
//   width: 14px;
//   height: 14px;
//   stroke-width: 2.2;
// }

//         /* =====================================================
//            SMALL MOBILE
//         ===================================================== */

//         @media (max-width: 480px) {

//           .sg-what {
//             padding: 65px 0;
//           }

//           .sg-what-title {
//             font-size: 35px;
//           }

//           .sg-process-heading {
//             font-size: 17px;
//           }

//           .sg-what-image-area {
//             min-height: 345px;
//           }

//           .sg-what-main-image {
//             height: 270px;
//           }

//           .sg-what-small-image {
//             height: 145px;

//             border-width: 6px;
//           }

//           .sg-what-image-card {
//             left: 8px;
//             bottom: 15px;

//             padding: 10px 12px;
//           }

//           .sg-divisions-title {
//             font-size: 28px;
//           }

//           .sg-division-card {
//             min-height: 60px;
//           }
//         }

//       `}</style>


//       <section
//         className="sg-what"
//         id="what-we-do"
//         ref={sectionRef}
//       >

//         <div className="sg-what-blueprint"></div>


//         <div className="sg-what-container">

//           {/* =================================================
//               HEADER
//           ================================================= */}

//           <div
//             className={`sg-what-heading ${visible ? "visible" : ""
//               }`}
//           >

//             <div>

//               <div className="sg-what-label">
//                 <span className="sg-what-label-line"></span>

//                 What We Do
//               </div>

//               <h2 className="sg-what-title">
//                 From Drawings
//                 <br />
//                 to <span>Bid-Ready Costs.</span>
//               </h2>

//             </div>

//             <p className="sg-what-description">
//               StructGuard transforms construction drawings and
//               project documents into organized quantity takeoffs
//               and detailed cost estimates. Our process is built
//               around <strong>accuracy, clarity, and consistency</strong>
//               so your team can make better bidding decisions.
//             </p>

//           </div>


//           {/* =================================================
//               PROCESS
//           ================================================= */}

//           <div className="sg-process">

//             <div className="sg-process-grid"></div>

//             <div className="sg-process-top">

//               <div className="sg-process-heading">
//                 Our Estimating Workflow
//               </div>

//               <div className="sg-process-tag">
//                 Structured • Reviewed • Delivered
//               </div>

//             </div>


//             <div className="sg-process-steps">

//               <div className="sg-process-line"></div>

//               {processSteps.map((step) => (

//                 <div
//                   className={`sg-process-step ${visible ? "visible" : ""
//                     }`}
//                   key={step.number}
//                 >

//                   <div className="sg-process-number">
//                     {step.number}
//                   </div>

//                   <div className="sg-process-icon">
//                     <step.icon />
//                   </div>

//                   <div className="sg-process-title">
//                     {step.title}
//                   </div>

//                   <div className="sg-process-subtitle">
//                     {step.subtitle}
//                   </div>

//                   <p className="sg-process-text">
//                     {step.description}
//                   </p>

//                 </div>

//               ))}

//             </div>

//           </div>


//           {/* =================================================
//               IMAGE + CONTENT
//           ================================================= */}

//           <div className="sg-what-main">

//             {/* IMAGE */}

//             <div
//               className={`sg-what-image-area ${visible ? "visible" : ""
//                 }`}
//             >

//               <img
//                 className="sg-what-main-image"
//                 src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1200&q=90"
//                 alt="Construction professionals reviewing a project"
//               />

//               <img
//                 className="sg-what-small-image"
//                 src="https://images.unsplash.com/photo-1542621334-a254cf47733d?auto=format&fit=crop&w=900&q=90"
//                 alt="Construction drawings and project plans"
//               />

//               <div className="sg-what-image-card">

//                 <div className="sg-what-image-card-icon">
//                   <FiCheckCircle />
//                 </div>

//                 <div>
//                   <strong>
//                     Scope Reviewed
//                   </strong>

//                   <span>
//                     Drawings • Specs • Schedules
//                   </span>
//                 </div>

//               </div>

//             </div>


//             {/* CONTENT */}

//             <div
//               className={`sg-what-content ${visible ? "visible" : ""
//                 }`}
//             >

//               <div className="sg-what-content-label">
//                 ESTIMATING SUPPORT
//               </div>

//               <h3 className="sg-what-content-title">
//                 The numbers behind
//                 <span> better bids.</span>
//               </h3>

//               <p className="sg-what-content-text">
//                 A construction estimate is more than a list of
//                 quantities. It requires a clear understanding of
//                 the drawings, project scope, specifications, and
//                 trade requirements.
//               </p>

//               <p className="sg-what-content-text">
//                 Our estimating workflow organizes this information
//                 into a practical format that helps contractors
//                 evaluate project costs before submitting a bid.
//               </p>


//               {/* FEATURES */}

//               <div className="sg-what-features">

//                 <div className="sg-what-feature">
//                   <div className="sg-what-feature-icon">
//                     <FiCheckCircle />
//                   </div>
//                   Accurate Quantity Takeoffs
//                 </div>

//                 <div className="sg-what-feature">
//                   <div className="sg-what-feature-icon">
//                     <FiDollarSign />
//                   </div>
//                   Material & Labor Costs
//                 </div>

//                 <div className="sg-what-feature">
//                   <div className="sg-what-feature-icon">
//                     <FiFileText />
//                   </div>
//                   Organized Estimate Reports
//                 </div>

//                 <div className="sg-what-feature">
//                   <div className="sg-what-feature-icon">
//                     <FiGrid />
//                   </div>
//                   Multi-Trade Estimating
//                 </div>

//                 <div className="sg-what-feature">
//                   <div className="sg-what-feature-icon">
//                     <FiSearch />
//                   </div>
//                   Drawing & Scope Review
//                 </div>

//                 <div className="sg-what-feature">
//                   <div className="sg-what-feature-icon">
//                     <FiArrowUpRight />
//                   </div>
//                   Bid Preparation Support
//                 </div>

//               </div>

//             </div>

//           </div>


//           {/* =================================================
//               CSI DIVISIONS
//           ================================================= */}

//           <div className="sg-divisions-section">

//             <div className="sg-divisions-header">

//               <div>

//                 <div className="sg-divisions-label">
//                   CSI DIVISION COVERAGE
//                 </div>

//                 <h3 className="sg-divisions-title">
//                   Estimating across the
//                   <br />
//                   construction scope.
//                 </h3>

//               </div>

//               <p className="sg-divisions-description">
//                 We support estimating requirements across
//                 multiple construction divisions, allowing
//                 contractors to work with one reliable
//                 estimating partner for diverse project scopes.
//               </p>

//             </div>


//             <div className="sg-divisions-grid">

//               {divisions.map((division) => (

//                 <div
//                   className="sg-division-card"
//                   key={division.number}
//                 >

//                   <div className="sg-division-number">
//                     {division.number}
//                   </div>

//                   <div>

//                     <strong>
//                       {division.name}
//                     </strong>

//                     <span>
//                       CSI Division
//                     </span>

//                   </div>

//                 </div>

//               ))}

//             </div>

//           </div>


//           {/* =================================================
//               CTA
//           ================================================= */}

//           {/* <div className="sg-what-cta">

//             <div>

//               <h3 className="sg-what-cta-title">
//                 Have drawings ready for estimating?
//               </h3>

//               <p className="sg-what-cta-text">
//                 Send us your project documents and let our team
//                 help you turn scope into clear cost information.
//               </p>

//             </div>

//             <a
//               href="#contact"
//               className="sg-what-cta-button"
//             >
//               REQUEST AN ESTIMATE
//               <span>↗</span>
//             </a>

//           </div> */}

//         </div>

//       </section>
//     </>
//   );
// };

// export default WhatWeDo;
import React, { useEffect, useRef, useState } from "react";
import {
  FiSearch,
  FiLayers,
  FiDollarSign,
  FiCheckCircle,
  FiArrowUpRight,
  FiFileText,
  FiBox,
  FiGrid,
  FiClipboard,
  FiTool,
  FiActivity,
  FiCpu,
  FiLayout,
} from "react-icons/fi";

const WhatWeDo = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [activeTab, setActiveTab] = useState("estimating");

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.12 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Services Data Configuration
  const servicesData = {
    estimating: {
      label: "Construction Estimating",
      titleTop: "From Drawings",
      titleHighlight: "to Bid-Ready Costs.",
      description: "StructGuard transforms construction drawings and project documents into organized quantity takeoffs and detailed cost estimates built around accuracy, clarity, and consistency.",
      processTitle: "Our Estimating Workflow",
      processTag: "Structured • Reviewed • Delivered",
      mainImage: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1200&q=90",
      smallImage: "https://images.unsplash.com/photo-1542621334-a254cf47733d?auto=format&fit=crop&w=900&q=90",
      contentLabel: "ESTIMATING SUPPORT",
      contentTitleText: "The numbers behind",
      contentTitleHighlight: "better bids.",
      textParagraphs: [
        "A construction estimate is more than a list of quantities. It requires a clear understanding of the drawings, project scope, specifications, and trade requirements.",
        "Our estimating workflow organizes this information into a practical format that helps contractors evaluate project costs before submitting a bid."
      ],
      features: [
        { icon: FiCheckCircle, text: "Accurate Quantity Takeoffs" },
        { icon: FiDollarSign, text: "Material & Labor Costs" },
        { icon: FiFileText, text: "Organized Estimate Reports" },
        { icon: FiGrid, text: "Multi-Trade Estimating" },
        { icon: FiSearch, text: "Drawing & Scope Review" },
        { icon: FiArrowUpRight, text: "Bid Preparation Support" },
      ],
      hasDivisions: true,
      steps: [
        { number: "01", title: "Review", subtitle: "Plans & Documents", description: "We review architectural drawings, structural plans, specifications, schedules, and project documents to understand the complete scope.", icon: FiSearch },
        { number: "02", title: "Takeoff", subtitle: "Quantities & Scope", description: "Our estimators measure and quantify materials, components, and trade-specific requirements from the project documents.", icon: FiLayers },
        { number: "03", title: "Estimate", subtitle: "Cost Development", description: "We organize material, labor, equipment, and other applicable costs into a structured construction estimate.", icon: FiDollarSign },
        { number: "04", title: "Review", subtitle: "Quality Control", description: "The estimate goes through a structured review to identify scope gaps, quantity inconsistencies, and potential errors.", icon: FiCheckCircle },
        { number: "05", title: "Deliver", subtitle: "Bid-Ready Output", description: "You receive a clear, organized estimate designed to help your team evaluate costs and prepare competitive bids.", icon: FiArrowUpRight },
      ]
    },
    preconstruction: {
      label: "Pre-Construction Services",
      titleTop: "Strategic Planning",
      titleHighlight: "Before Breaking Ground.",
      description: "We set projects up for success through comprehensive budgeting, feasibility analysis, value engineering, and meticulous milestone scheduling.",
      processTitle: "Pre-Construction Workflow",
      processTag: "Analyze • Plan • Optimize",
      mainImage: "https://images.unsplash.com/photo-1531834685032-c34f0d8fadc2?auto=format&fit=crop&w=1200&q=90",
      smallImage: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=900&q=90",
      contentLabel: "PRE-CONSTRUCTION STAGE",
      contentTitleText: "Mitigating risks",
      contentTitleHighlight: "early on.",
      textParagraphs: [
        "Successful construction projects begin long before physical work starts on site. Our pre-construction services focus on aligning project vision with budget reality.",
        "We evaluate constructability, analyze potential site constraints, and optimize specifications to save cost and time."
      ],
      features: [
        { icon: FiClipboard, text: "Feasibility Studies" },
        { icon: FiDollarSign, text: "Conceptual Budgeting" },
        { icon: FiTool, text: "Value Engineering" },
        { icon: FiActivity, text: "Schedule Development" },
        { icon: FiSearch, text: "Constructability Review" },
        { icon: FiFileText, text: "Procurement Strategy" },
      ],
      hasDivisions: false,
      steps: [
        { number: "01", title: "Scope", subtitle: "Alignment", description: "Define project objectives, design criteria, and functional requirements with all stakeholders.", icon: FiSearch },
        { number: "02", title: "Budget", subtitle: "Establishment", description: "Develop initial conceptual estimates and cost models aligned with financial targets.", icon: FiDollarSign },
        { number: "03", title: "Analyze", subtitle: "Constructability", description: "Review designs to identify potential site clashes, logistics constraints, and material long-leads.", icon: FiTool },
        { number: "04", title: "Optimize", subtitle: "Value Engineering", description: "Explore alternative materials and methods to optimize cost without compromising quality.", icon: FiCheckCircle },
        { number: "05", title: "Plan", subtitle: "Master Schedule", description: "Deliver a comprehensive pre-construction report and master schedule ready for execution.", icon: FiArrowUpRight },
      ]
    },
    bim: {
      label: "BIM Services",
      titleTop: "Intelligent Modeling",
      titleHighlight: "& Clash Detection.",
      description: "Leveraging cutting-edge Building Information Modeling (BIM) to coordinate trades, visualize structures digitally, and eliminate on-site conflicts.",
      processTitle: "BIM Coordination Workflow",
      processTag: "Model • Coordinate • Construct",
      mainImage: "https://images.unsplash.com/photo-1581092160607-ee22621dd758?auto=format&fit=crop&w=1200&q=90",
      smallImage: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=900&q=90",
      contentLabel: "DIGITAL CONSTRUCTION",
      contentTitleText: "Building virtually",
      contentTitleHighlight: "before reality.",
      textParagraphs: [
        "Our BIM services provide multi-disciplinary digital modeling that bridges the gap between design intent and field installation.",
        "We detect structural and MEP clashes early in the office, drastically reducing costly rework and delays out in the field."
      ],
      features: [
        { icon: FiBox, text: "3D Parametric Modeling" },
        { icon: FiCpu, text: "Clash Detection & Resolution" },
        { icon: FiLayers, text: "Multi-Disciplinary Coordination" },
        { icon: FiFileText, text: "Shop Drawing Generation" },
        { icon: FiGrid, text: "BIM Quantity Extraction" },
        { icon: FiLayout, text: "As-Built Modeling" },
      ],
      hasDivisions: false,
      steps: [
        { number: "01", title: "Ingest", subtitle: "Source Data", description: "Gather architectural, structural, and MEP drawings to build foundational digital models.", icon: FiSearch },
        { number: "02", title: "Model", subtitle: "Creation", description: "Develop detailed 3D components incorporating accurate geometry and technical parameters.", icon: FiBox },
        { number: "03", title: "Coordinate", subtitle: "Clash Detection", description: "Run automated and manual clash tests across structural and service trades.", icon: FiCpu },
        { number: "04", title: "Resolve", subtitle: "Refinement", description: "Collaborate with engineers and contractors to resolve spatial and routing conflicts.", icon: FiCheckCircle },
        { number: "05", title: "Deliver", subtitle: "Coordinated Output", description: "Publish final coordinated models, clash reports, and precision shop drawings.", icon: FiArrowUpRight },
      ]
    },
    engineering: {
      label: "Project Engineering",
      titleTop: "Technical Oversight",
      titleHighlight: "& Execution Support.",
      description: "Providing robust engineering support, design verification, structural evaluations, and technical documentation throughout project lifecycles.",
      processTitle: "Project Engineering Workflow",
      processTag: "Evaluate • Design • Verify",
      mainImage: "https://images.unsplash.com/photo-1581092335397-9583fe92d232?auto=format&fit=crop&w=1200&q=90",
      smallImage: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=900&q=90",
      contentLabel: "ENGINEERING EXCELLENCE",
      contentTitleText: "Rigorous standards",
      contentTitleHighlight: "every step.",
      textParagraphs: [
        "As structural engineers, we understand the critical balance between structural integrity, safety compliance, and construction efficiency.",
        "Our project engineering solutions offer dependable technical oversight, documentation management, and structural consultation."
      ],
      features: [
        { icon: FiTool, text: "Structural Verification" },
        { icon: FiFileText, text: "Technical Submittals" },
        { icon: FiCheckCircle, text: "Code Compliance Review" },
        { icon: FiActivity, text: "Site Support & Consultation" },
        { icon: FiLayers, text: "Design Optimization" },
        { icon: FiClipboard, text: "Engineering Audits" },
      ],
      hasDivisions: false,
      steps: [
        { number: "01", title: "Assess", subtitle: "Requirements", description: "Analyze structural parameters, design criteria, and operational performance goals.", icon: FiSearch },
        { number: "02", title: "Review", subtitle: "Engineering Data", description: "Evaluate calculations, specifications, and regulatory codes for full compliance.", icon: FiFileText },
        { number: "03", title: "Formulate", subtitle: "Solutions", description: "Develop practical engineering solutions and design adaptations for site queries.", icon: FiTool },
        { number: "04", title: "Verify", subtitle: "Quality Assurance", description: "Perform rigorous checks to ensure safety factors and structural reliability standards.", icon: FiCheckCircle },
        { number: "05", title: "Execute", subtitle: "Documentation", description: "Provide certified technical submittals, reports, and execution guidelines.", icon: FiArrowUpRight },
      ]
    }
  };

  const currentService = servicesData[activeTab];

  const divisions = [
    { number: "01", name: "General Requirements / GC" },
    { number: "02", name: "Existing Conditions" },
    { number: "03", name: "Concrete" },
    { number: "04", name: "Masonry" },
    { number: "05", name: "Metals" },
    { number: "07", name: "Thermal & Moisture Protection" },
    { number: "08", name: "Openings" },
    { number: "09", name: "Finishes" },
    { number: "32", name: "Exterior Improvements" },
  ];

  return (
    <>
      <style>{`
        /* =====================================================
           WHAT WE DO & SERVICES STYLES
        ===================================================== */

        .sg-what {
          position: relative;
          overflow: hidden;
          padding: 125px 0;
          background: #ffffff;
        }

        .sg-what-container {
          position: relative;
          z-index: 2;
          width: min(1380px, 92%);
          margin: auto;
        }

        /* SERVICE TAB NAVIGATION */
        .sg-service-tabs {
          display: flex;
          justify-content: center;
          gap: 12px;
          margin-bottom: 50px;
          flex-wrap: wrap;
        }

        .sg-service-tab-btn {
          padding: 12px 22px;
          border: 1px solid #d6e2f1;
          border-radius: 30px;
          background: #f7faff;
          color: #4a5c75;
          font-size: 13px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.25s ease;
        }

        .sg-service-tab-btn:hover {
          border-color: #1558c0;
          color: #1558c0;
        }

        .sg-service-tab-btn.active {
          background: #1558c0;
          color: #ffffff;
          border-color: #1558c0;
          box-shadow: 0 8px 20px rgba(21, 88, 192, 0.25);
        }

        /* BACKGROUND BLUEPRINT */
        .sg-what-blueprint {
          position: absolute;
          right: -180px;
          top: 180px;
          width: 650px;
          height: 650px;
          opacity: 0.38;
          background-image:
            linear-gradient(rgba(25, 88, 175, 0.055) 1px, transparent 1px),
            linear-gradient(90deg, rgba(25, 88, 175, 0.055) 1px, transparent 1px);
          background-size: 35px 35px;
          transform: rotate(7deg);
          pointer-events: none;
        }

        /* SECTION HEADER */
        .sg-what-heading {
          display: grid;
          grid-template-columns: 0.9fr 1.1fr;
          gap: 80px;
          align-items: end;
          margin-bottom: 70px;
          opacity: 0;
          transform: translateY(30px);
          transition: opacity 0.75s ease, transform 0.75s ease;
        }

        .sg-what-heading.visible {
          opacity: 1;
          transform: translateY(0);
        }

        .sg-what-label {
          display: inline-flex;
          align-items: center;
          gap: 9px;
          margin-bottom: 16px;
          color: #175bc3;
          font-size: 12px;
          font-weight: 800;
          letter-spacing: 1.5px;
          text-transform: uppercase;
        }

        .sg-what-label-line {
          width: 30px;
          height: 2px;
          border-radius: 10px;
          background: #f39818;
        }

        .sg-what-title {
          margin: 0;
          color: #10213f;
          font-size: clamp(36px, 4vw, 58px);
          line-height: 1.05;
          letter-spacing: -2px;
          font-weight: 800;
        }

        .sg-what-title span {
          color: #1b60c8;
        }

        .sg-what-description {
          max-width: 650px;
          margin: 0;
          color: #68768a;
          font-size: 16px;
          line-height: 1.8;
        }

        /* PROCESS VISUAL */
        .sg-process {
          position: relative;
          margin-top: 20px;
          padding: 45px 35px 42px;
          border: 1px solid #dfe8f2;
          border-radius: 24px;
          background: linear-gradient(135deg, #f8fbff 0%, #ffffff 50%, #f7faff 100%);
          box-shadow: 0 20px 55px rgba(25, 61, 103, 0.07);
          overflow: hidden;
        }

        .sg-process-grid {
          position: absolute;
          inset: 0;
          opacity: 0.55;
          background-image:
            linear-gradient(rgba(31, 91, 177, 0.04) 1px, transparent 1px),
            linear-gradient(90deg, rgba(31, 91, 177, 0.04) 1px, transparent 1px);
          background-size: 28px 28px;
          pointer-events: none;
        }

        .sg-process-top {
          position: relative;
          z-index: 2;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 45px;
        }

        .sg-process-heading {
          color: #10213f;
          font-size: 20px;
          font-weight: 800;
        }

        .sg-process-tag {
          padding: 8px 13px;
          border: 1px solid #d6e2f1;
          border-radius: 20px;
          color: #5c6d83;
          background: #ffffff;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.7px;
          text-transform: uppercase;
        }

        /* PROCESS STEPS */
        .sg-process-steps {
          position: relative;
          z-index: 2;
          display: grid;
          grid-template-columns: repeat(5, minmax(0, 1fr));
          gap: 12px;
        }

        .sg-process-line {
          position: absolute;
          left: 9%;
          right: 9%;
          top: 38px;
          height: 2px;
          background: repeating-linear-gradient(90deg, #c7d8ed 0, #c7d8ed 7px, transparent 7px, transparent 14px);
        }

        .sg-process-step {
          position: relative;
          text-align: center;
          opacity: 0;
          transform: translateY(25px);
          transition: opacity 0.6s ease, transform 0.6s ease;
        }

        .sg-process-step.visible {
          opacity: 1;
          transform: translateY(0);
        }

        .sg-process-step:nth-child(2) { transition-delay: 0.1s; }
        .sg-process-step:nth-child(3) { transition-delay: 0.2s; }
        .sg-process-step:nth-child(4) { transition-delay: 0.3s; }
        .sg-process-step:nth-child(5) { transition-delay: 0.4s; }

        .sg-process-number {
          position: relative;
          z-index: 4;
          width: 76px;
          height: 76px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: auto;
          border: 7px solid #f8fbff;
          border-radius: 50%;
          color: #ffffff;
          background: linear-gradient(145deg, #1558c0, #2874dd);
          font-size: 17px;
          font-weight: 900;
          box-shadow: 0 10px 25px rgba(21, 88, 192, 0.22);
        }

        .sg-process-icon {
          position: absolute;
          z-index: 5;
          top: -4px;
          right: calc(50% - 38px);
          transform: translateX(50%);
          width: 23px;
          height: 23px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: #f39818;
          color: white;
          font-size: 10px;
          font-weight: 900;
          border: 3px solid #ffffff;
        }

        .sg-process-title {
          margin: 19px 0 5px;
          color: #172945;
          font-size: 16px;
          font-weight: 800;
        }

        .sg-process-subtitle {
          color: #1558c0;
          font-size: 10px;
          font-weight: 800;
          letter-spacing: 0.5px;
          text-transform: uppercase;
        }

        .sg-process-text {
          max-width: 190px;
          margin: 12px auto 0;
          color: #7a8799;
          font-size: 10.5px;
          line-height: 1.65;
        }

        /* IMAGE + MESSAGE */
        .sg-what-main {
          display: grid;
          grid-template-columns: 0.9fr 1.1fr;
          gap: 80px;
          align-items: center;
          margin-top: 100px;
        }

        .sg-what-image-area {
          position: relative;
          min-height: 480px;
          opacity: 0;
          transform: translateX(-35px);
          transition: opacity 0.8s ease, transform 0.8s ease;
        }

        .sg-what-image-area.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .sg-what-main-image {
          position: absolute;
          top: 0;
          left: 0;
          width: 84%;
          height: 385px;
          object-fit: cover;
          border-radius: 21px;
          box-shadow: 0 25px 55px rgba(25, 58, 97, 0.17);
        }

        .sg-what-small-image {
          position: absolute;
          z-index: 3;
          right: 0;
          bottom: 5px;
          width: 50%;
          height: 210px;
          object-fit: cover;
          border: 9px solid #ffffff;
          border-radius: 18px;
          box-shadow: 0 18px 40px rgba(25, 58, 97, 0.17);
        }

        .sg-what-image-card {
          position: absolute;
          z-index: 5;
          left: 25px;
          bottom: 25px;
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 13px 16px;
          border-radius: 12px;
          background: rgba(255,255,255,0.94);
          box-shadow: 0 15px 35px rgba(25,58,97,0.15);
          backdrop-filter: blur(12px);
        }

        .sg-what-image-card-icon {
          width: 39px;
          height: 39px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 9px;
          color: #1558c0;
          background: #eaf2ff;
          font-size: 17px;
        }

        .sg-what-image-card strong {
          display: block;
          color: #172945;
          font-size: 12px;
        }

        .sg-what-image-card span {
          display: block;
          margin-top: 3px;
          color: #8793a3;
          font-size: 9px;
        }

        /* RIGHT CONTENT */
        .sg-what-content {
          opacity: 0;
          transform: translateX(35px);
          transition: opacity 0.8s ease 0.12s, transform 0.8s ease 0.12s;
        }

        .sg-what-content.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .sg-what-content-label {
          color: #f39818;
          font-size: 11px;
          font-weight: 800;
          letter-spacing: 1.3px;
          text-transform: uppercase;
        }

        .sg-what-content-title {
          max-width: 620px;
          margin: 11px 0 18px;
          color: #10213f;
          font-size: clamp(30px, 3.1vw, 45px);
          line-height: 1.12;
          letter-spacing: -1.5px;
          font-weight: 800;
        }

        .sg-what-content-title span {
          color: #1b60c8;
        }

        .sg-what-content-text {
          max-width: 620px;
          margin: 0 0 18px;
          color: #68768a;
          font-size: 14px;
          line-height: 1.8;
        }

        /* FEATURE LIST */
        .sg-what-features {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 13px;
          margin-top: 28px;
        }

        .sg-what-feature {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 13px;
          border: 1px solid #e4ebf3;
          border-radius: 10px;
          background: #fbfdff;
          color: #40516a;
          font-size: 11px;
          font-weight: 700;
        }

        .sg-what-feature-icon {
          width: 27px;
          height: 27px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 7px;
          color: #1558c0;
          background: #eaf2ff;
          font-size: 11px;
        }

        /* CSI DIVISIONS */
        .sg-divisions-section {
          margin-top: 105px;
          padding: 50px;
          border-radius: 22px;
          background: linear-gradient(135deg, #102b4d, #174d88);
          box-shadow: 0 25px 60px rgba(15, 48, 85, 0.18);
          overflow: hidden;
          position: relative;
        }

        .sg-divisions-header {
          position: relative;
          z-index: 2;
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          gap: 40px;
          margin-bottom: 35px;
        }

        .sg-divisions-label {
          color: #f7a62c;
          font-size: 10px;
          font-weight: 800;
          letter-spacing: 1.4px;
          text-transform: uppercase;
        }

        .sg-divisions-title {
          max-width: 600px;
          margin: 9px 0 0;
          color: #ffffff;
          font-size: clamp(28px, 3vw, 40px);
          line-height: 1.15;
          letter-spacing: -1px;
          font-weight: 800;
        }

        .sg-divisions-description {
          max-width: 430px;
          margin: 0;
          color: rgba(255,255,255,0.68);
          font-size: 12px;
          line-height: 1.7;
        }

        .sg-divisions-grid {
          position: relative;
          z-index: 2;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 10px;
        }

        .sg-division-card {
          display: flex;
          align-items: center;
          gap: 12px;
          min-height: 65px;
          padding: 10px 14px;
          border: 1px solid rgba(255,255,255,0.10);
          border-radius: 10px;
          background: rgba(255,255,255,0.065);
        }

        .sg-division-number {
          width: 37px;
          height: 37px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 8px;
          color: #174f9b;
          background: #ffffff;
          font-size: 11px;
          font-weight: 900;
        }

        .sg-division-card strong {
          display: block;
          color: #ffffff;
          font-size: 11px;
          line-height: 1.35;
        }

        .sg-division-card span {
          display: block;
          margin-top: 3px;
          color: rgba(255,255,255,0.46);
          font-size: 8px;
          letter-spacing: 0.5px;
          text-transform: uppercase;
        }

        /* RESPONSIVE MEDIA QUERIES */
        @media (max-width: 1000px) {
          .sg-what { padding: 95px 0; }
          .sg-what-heading { gap: 40px; }
          .sg-process { padding: 35px 20px; }
          .sg-process-steps { gap: 5px; }
        }

        @media (max-width: 760px) {
          .sg-what { padding: 80px 0; }
          .sg-what-heading { grid-template-columns: 1fr; gap: 18px; text-align: center; }
          .sg-what-label { justify-content: center; }
          .sg-process-steps { grid-template-columns: 1fr; gap: 25px; }
          .sg-process-line { left: 50%; width: 2px; height: auto; }
          .sg-what-main { grid-template-columns: 1fr; gap: 45px; }
          .sg-divisions-grid { grid-template-columns: 1fr; }
        }
      `}</style>

      <section className="sg-what" id="what-we-do" ref={sectionRef}>
        <div className="sg-what-blueprint"></div>

        <div className="sg-what-container">
          
          {/* =================================================
              SERVICE SWITCHING TABS
          ================================================= */}
          <div className="sg-service-tabs">
            <button 
              className={`sg-service-tab-btn ${activeTab === "estimating" ? "active" : ""}`}
              onClick={() => setActiveTab("estimating")}
            >
              Construction Estimating
            </button>
            <button 
              className={`sg-service-tab-btn ${activeTab === "preconstruction" ? "active" : ""}`}
              onClick={() => setActiveTab("preconstruction")}
            >
              Pre-Construction Services
            </button>
            <button 
              className={`sg-service-tab-btn ${activeTab === "bim" ? "active" : ""}`}
              onClick={() => setActiveTab("bim")}
            >
              BIM Services
            </button>
            <button 
              className={`sg-service-tab-btn ${activeTab === "engineering" ? "active" : ""}`}
              onClick={() => setActiveTab("engineering")}
            >
              Project Engineering
            </button>
          </div>

          {/* =================================================
              HEADER
          ================================================= */}
          <div className={`sg-what-heading ${visible ? "visible" : ""}`}>
            <div>
              <div className="sg-what-label">
                <span className="sg-what-label-line"></span>
                {currentService.label}
              </div>
              <h2 className="sg-what-title">
                {currentService.titleTop}
                <br />
                <span>{currentService.titleHighlight}</span>
              </h2>
            </div>
            <p className="sg-what-description">
              {currentService.description}
            </p>
          </div>

          {/* =================================================
              PROCESS FLOW SECTION
          ================================================= */}
          <div className="sg-process">
            <div className="sg-process-grid"></div>
            <div className="sg-process-top">
              <div className="sg-process-heading">
                {currentService.processTitle}
              </div>
              <div className="sg-process-tag">
                {currentService.processTag}
              </div>
            </div>

            <div className="sg-process-steps">
              <div className="sg-process-line"></div>
              {currentService.steps.map((step) => (
                <div
                  className={`sg-process-step ${visible ? "visible" : ""}`}
                  key={step.number}
                >
                  <div className="sg-process-number">{step.number}</div>
                  <div className="sg-process-icon">
                    <step.icon />
                  </div>
                  <div className="sg-process-title">{step.title}</div>
                  <div className="sg-process-subtitle">{step.subtitle}</div>
                  <p className="sg-process-text">{step.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* =================================================
              IMAGE + CONTENT SECTION
          ================================================= */}
          <div className="sg-what-main">
            {/* IMAGE AREA */}
            <div className={`sg-what-image-area ${visible ? "visible" : ""}`}>
              <img
                className="sg-what-main-image"
                src={currentService.mainImage}
                alt={currentService.label}
              />
              <img
                className="sg-what-small-image"
                src={currentService.smallImage}
                alt="Secondary project detail"
              />
              <div className="sg-what-image-card">
                <div className="sg-what-image-card-icon">
                  <FiCheckCircle />
                </div>
                <div>
                  <strong>Professional Standards</strong>
                  <span>Quality Assured</span>
                </div>
              </div>
            </div>

            {/* CONTENT AREA */}
            <div className={`sg-what-content ${visible ? "visible" : ""}`}>
              <div className="sg-what-content-label">
                {currentService.contentLabel}
              </div>
              <h3 className="sg-what-content-title">
                {currentService.contentTitleText}
                <span> {currentService.contentTitleHighlight}</span>
              </h3>
              
              {currentService.textParagraphs.map((para, idx) => (
                <p className="sg-what-content-text" key={idx}>
                  {para}
                </p>
              ))}

              {/* FEATURES GRID */}
              <div className="sg-what-features">
                {currentService.features.map((feat, idx) => (
                  <div className="sg-what-feature" key={idx}>
                    <div className="sg-what-feature-icon">
                      <feat.icon />
                    </div>
                    {feat.text}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* =================================================
              CSI DIVISIONS (Visible on Estimating Tab)
          ================================================= */}
          {currentService.hasDivisions && (
            <div className="sg-divisions-section">
              <div className="sg-divisions-header">
                <div>
                  <div className="sg-divisions-label">
                    CSI DIVISION COVERAGE
                  </div>
                  <h3 className="sg-divisions-title">
                    Estimating across the
                    <br />
                    construction scope.
                  </h3>
                </div>
                <p className="sg-divisions-description">
                  We support estimating requirements across multiple construction divisions, allowing contractors to work with one reliable estimating partner.
                </p>
              </div>

              <div className="sg-divisions-grid">
                {divisions.map((division) => (
                  <div className="sg-division-card" key={division.number}>
                    <div className="sg-division-number">{division.number}</div>
                    <div>
                      <strong>{division.name}</strong>
                      <span>CSI Division</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

        </div>
      </section>
    </>
  );
};

export default WhatWeDo;